import { Card, TextField } from "@mui/material";
import { motion } from "framer-motion";
import React, { ChangeEvent } from "react";

import {
  SafeArgonBox,
  SafeArgonTypography,
  SafeArgonButton as Button,
} from "0.Mine/4.Argon/ArgonComponents";

import { ColorPicker } from "../Reusable/ColorPicker";
import { ImageDropzone } from "../Reusable/ImageDropzone";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0 },
};

const WhiteLabelForm = () => {
  const [hasPrerequisites] = React.useState(false);
  const [logo, setLogo] = React.useState(null);
  const [name, setName] = React.useState("");
  const [footerLink, setFooterLink] = React.useState("");
  const [color, setColor] = React.useState("#000000");

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = { logo, name, footerLink, color };
    console.log("Submitting form:", formData);
    localStorage.setItem("IsWhiteLabelPartner", "true");
    localStorage.setItem("whiteLabelData", JSON.stringify(formData));
  };

  if (!hasPrerequisites) {
    return (
      <Card id="white-label-form" sx={{ padding: 3 }}>
        <SafeArgonBox>
          <p>Non hai i prerequisiti per diventare un white label partner.</p>
        </SafeArgonBox>
      </Card>
    );
  }

  return (
    <Card id="white-label-form" sx={{ padding: 3 }}>
      <motion.div initial="hidden" animate="visible" variants={containerVariants}>
        <SafeArgonBox>White Label Partner Options</SafeArgonBox>
        <form onSubmit={handleSubmit}>
          <SafeArgonBox component={motion.div} variants={itemVariants} mb={2}>
            <SafeArgonTypography>Your Logo</SafeArgonTypography>
            <ImageDropzone onDropFile={(file) => setLogo(file)} initialImage={logo} />
          </SafeArgonBox>

          <SafeArgonBox component={motion.div} variants={itemVariants} mb={2}>
            <TextField
              fullWidth
              label="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </SafeArgonBox>

          <SafeArgonBox component={motion.div} variants={itemVariants} mb={2}>
            <TextField
              fullWidth
              label="Your Footer Link"
              value={footerLink}
              onChange={(e) => setFooterLink(e.target.value)}
            />
          </SafeArgonBox>

          <SafeArgonBox component={motion.div} variants={itemVariants} mb={2}>
            <ColorPicker
              label="Your Preferred Colour"
              value={color}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setColor(e.target.value)}
            />
          </SafeArgonBox>

          <SafeArgonBox component={motion.div} variants={itemVariants} mt={3}>
            <Button type="submit" variant="contained" fullWidth>
              Submit
            </Button>
          </SafeArgonBox>
        </form>
      </motion.div>
    </Card>
  );
};

export default WhiteLabelForm;
